import { render, staticRenderFns } from "./submitBtnSetting.vue?vue&type=template&id=39f2ee0e&scoped=true"
import script from "./submitBtnSetting.vue?vue&type=script&lang=ts"
export * from "./submitBtnSetting.vue?vue&type=script&lang=ts"
import style0 from "./submitBtnSetting.vue?vue&type=style&index=0&id=39f2ee0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2ee0e",
  null
  
)

export default component.exports